import React from "react";
import "./../componts/styles.css";

export default function Blog() {
  return (
    <>
      <div className="mx-auto border-2 border-yellow-800 p-8">
        <div className="header">
          <h2>Blog Name</h2>
        </div>

        <div className="row">
          <div className="leftcolumn">
            <div className="card">
              <h2>TITLE HEADING</h2>
              <h5>Title description, Dec 7, 2017</h5>
              <div className="fakeimg" style={{ height: "200px" }}>
                image
              </div>
              <p>Some text..</p>
              <p>
                Sunt in culpa qui officia deserunt mollit anim id est laborum
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco.
              </p>
            </div>
            <div className="card">
              <h2>TITLE HEADING</h2>
              <h5>Title description, Sep 2, 2017</h5>
              <div className="fakeimg" style={{ height: "200px" }}>
                image
              </div>
              <p>Some text..</p>
              <p>
                Sunt in culpa qui officia deserunt mollit anim id est laborum
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco.
              </p>
            </div>
          </div>
          <div className="rightcolumn">
            <div className="card">
              <h2>About Me</h2>
              <div className="fakeimg" style={{ height: "100px" }}>
                image
              </div>
              <p>
                Some text about me in culpa qui officia deserunt mollit anim..
              </p>
            </div>
            <div className="card">
              <h3>Popular Post</h3>
              <div className="fakeimg">image</div>
              <br />
              <div className="fakeimg">image</div>
              <br />
              <div className="fakeimg">image</div>
            </div>
            <div className="card">
              <h3>Follow Me</h3>
              <p>Some text..</p>
            </div>
          </div>
        </div>

        <div className="footer">
          <h2>Footer</h2>
        </div>
          </div>
          
      {/* <div className="mx-auto border-2 border-yellow-800 p-8"> */}

      {/* <div className="border-2 border-green-400 ">
          <Swiper
            // Coverflow effect with rotation and depth
            // effect={"coverflow"}
            grabCursor={true} // Makes the cursor look like a hand
            centeredSlides={true} // Centers the slides
            slidesPerView={3} // Display 3 slides at once
            // coverflowEffect={{
            //   rotate: 160, // How much to rotate the slides
            //   stretch: 120, // Space between slides
            //   depth: 250, // How deep the slides go
            //   modifier: 2, // Multiplies the effects
            //   slideShadows: true, // Adds shadows behind slides
            // }}
            autoplay={{
              // Autoplay settings
              delay: 1000, // Delay before switching to the next slide
              disableOnInteraction: false, // Keeps autoplay even when the user interacts with the slider
            }}
            pagination={{ clickable: true }} // Allows pagination dots to be clickable
            navigation={true} // Adds next/previous navigation arrows
            modules={[Navigation, Pagination, EffectCoverflow, Autoplay]} // Include the modules you want to use
            className="customSwiper h-[500px]"
            loop={true} // Loops through slides infinitely
            breakpoints={{
              // When window width is >= 768px
              768: {
                slidesPerView: 3, // 3 slides per view for larger screens
              },
              // When window width is < 768px
              0: {
                slidesPerView: 1, // 1 slide per view for small screens
              },
            }}
          >
            {/* SwiperSlide 1 - Example of an image */}
      {/* <SwiperSlide> 
              <div>
                <img src={img} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img src={img} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img src={img} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img src={img} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
          </Swiper>
         </div> 
        */}
      {/* </div> */}
    </>
  );
}
